export default __webpack_public_path__ + "static/media/react-app-env.d.ts.1bd73092.txt";